import React, { useState } from "react";
import { Button, FormControl, IconButton, List, ListItem } from "@mui/material";
import Add from "@mui/icons-material/Add";

import {
  ModalButtonContainer,
  NegativeModalButton,
  PositiveModalButton,
} from "../../../components/Button";
import { useModal } from "../../../components/modal";
import { CustomTextField } from "../../../components/TextFields";
import TextContainer from "../../../components/Texts/TextContainer";
import { useAddCoursesMutation } from "../../../app/services/organ.api";
import LoadingButton from "../../../components/Button/LoadingButton";

export default function Addmodal({ organId }: { organId: string }) {
  const { setShow } = useModal();
  const [items, setItems] = useState<string[]>([]);
  const [currentId, setCurrentId] = useState("");
  const [err, setError] = useState<string>("");
  const [addCourses, addState] = useAddCoursesMutation();

  const handleAddItem = () => {
    const exp = /^(?=[a-f\d]{24}$)(\d+[a-f]|[a-f]+\d)/i;
    if (exp.test(currentId)) {
      setError("");
      setItems((prevItems) => [...prevItems, currentId]);
      setCurrentId("");
      return;
    }
    setError("شماره سریال دوره الزامی می باشد");
  };

  return (
    <React.Fragment>
      <FormControl fullWidth>
        <List sx={{ width: "100%" }}>
          <ListItem sx={{ display: "flex", gap: ".5rem" }}>
            <CustomTextField
              required
              label="شماره سریال دوره"
              placeholder="شماره سریال دوره را وارد کنید."
              variant="outlined"
              value={currentId}
              onChange={(e: any) => setCurrentId(e.target.value)}
              error={err.length >= 0}
              style={{ margin: 0 }}
              helperText={err}
            />
            <IconButton
              sx={{
                color: "secondary.main",
                border: "1px solid white",
                borderRadius: "10px",
                width: "fit-content",
              }}
              size="large"
              onClick={() => handleAddItem()}
            >
              <Add />
            </IconButton>
          </ListItem>
          {items.map((item: any, index: number) => (
            <ListItem key={item.id} sx={{ gap: ".5rem" }}>
              <TextContainer color="customColors.purple">
                {index + 1}.
              </TextContainer>
              &nbsp;
              {item}
            </ListItem>
          ))}
        </List>
      </FormControl>
      <ModalButtonContainer>
        <Button
          style={NegativeModalButton}
          sx={{
            color: "divider",
            bgcolor: "primary.main",
            borderStyle: "solid",
            borderWidth: "1px",
            borderColor: "divider",
            ":hover": {
              bgcolor: "divider",
              color: "primary.main",
            },
          }}
          onClick={() => setShow(false)}
        >
          انصراف
        </Button>
        <LoadingButton
          style={PositiveModalButton}
          sx={{
            ":hover": {
              bgcolor: "customColors.purple",
              color: "secondary.main",
            },
          }}
          isLoading={addState.isLoading}
          onClick={() => {
            if (items.length) {
              addCourses({ organId, data: items })
                .unwrap()
                .then(() => setShow(false))
                .catch(() => {});
            }
          }}
        >
          تایید
        </LoadingButton>
      </ModalButtonContainer>
    </React.Fragment>
  );
}
